module.exports = __webpack_public_path__ + "img/company2.d3d1952f.png";